var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('img', _vm._g(_vm._b({
    key: _vm.nSrc,
    ref: "img",
    attrs: {
      "src": _vm.nSrc
    }
  }, 'img', _vm.nAttrs, false), _vm.$listeners));

}
var staticRenderFns = []

export { render, staticRenderFns }